import React from 'react';
import './FilterOptionChecks.css';

const FilterOptionChecks = ({ index, active, filters, filterCheckHandler }) => (
  <div className={`FilterOptionChecks--container ${active ? 'active' : ''}`}>
    <div className="FilterOptionChecks--wrapper">
      {filters.map((filter, filterIndex) => (
        <div key={filter.name} className="FilterOptionChecks--checkbox-group checkbox-group">
          <input
            onChange={e => filterCheckHandler(index, filterIndex, e)}
            type="checkbox"
            name={filter.name}
            checked={filter.checked}
            className="FilterOptionChecks--input"
          />
          <label
            dangerouslySetInnerHTML={{ __html: filter.name }}
            className={filter.name === 'STEM Designated Programs' ? 'FilterOptionChecks--label stem-filter' : 'FilterOptionChecks--label'}
          />
        </div>
      ))}
    </div>
  </div>
);

export default FilterOptionChecks;
